import { Link } from "react-router-dom";
import { MdMap } from "react-icons/md";
import {
  HomeIcon,
  NewspaperIcon,
  BuildingOffice2Icon,
  DocumentMagnifyingGlassIcon,
  WrenchScrewdriverIcon,
} from "@heroicons/react/24/outline";

const sections = [
  {
    title: "Início",
    Icon: HomeIcon,
    links: [
      { name: "Página Inicial", href: "/" },
    ],
  },
  {
    title: "Prefeitura",
    Icon: BuildingOffice2Icon,
    links: [
      { name: "História de Serrinha", href: "/historia" },
      { name: "Gestão Municipal", href: "/governo" },
      { name: "Prefeito", href: "/prefeito" },
      { name: "Vice-prefeito", href: "/vice-prefeito" },
      { name: "Secretarias Municipais", href: "/secretarias" },
    ],
  },
  {
    title: "Notícias",
    Icon: NewspaperIcon,
    links: [
      { name: "Todas as Notícias", href: "/noticias" },
    ],
  },
  {
    title: "Portal da Transparência",
    Icon: DocumentMagnifyingGlassIcon,
    links: [
      { name: "Portal da Transparência", href: "/transparencia" },
      { name: "Gestão Anterior", href: "/transparencia/anterior" },
      { name: "Estrutura Organizacional", href: "/transparencia/estrutura-organizacional" },
      { name: "Carta de Serviços", href: "/transparencia/carta-de-servicos" },
      { name: "Canais de Comunicação", href: "/transparencia/canais-de-comunicacao" },
      { name: "Ouvidoria", href: "/transparencia/ouvidoria" },
      { name: "Perguntas e Respostas", href: "/transparencia/perguntas-e-respostas" },
      { name: "Redes Sociais", href: "/transparencia/redes-sociais" },
      { name: "Declaração", href: "/transparencia/declaracao" },
    ],
  },
  {
    title: "Acessibilidade",
    Icon: WrenchScrewdriverIcon,
    links: [
      { name: "Acessibilidade", href: "/transparencia/acessibilidade" },
      { name: "Alto Contraste", href: "/transparencia/acessibilidade/alto-contraste" },
      { name: "Redimensionamento de Texto", href: "/transparencia/acessibilidade/redimensionamento-de-texto" },
      { name: "Mapa do Site", href: "/transparencia/acessibilidade/mapa-do-site" },
    ],
  },
];

const SiteMap = () => (
  <div className="p-8 space-y-8">
    <div className="flex items-center gap-3">
      <MdMap className="text-4xl text-blue-900 flex-shrink-0" />
      <div>
        <h2 className="text-xl font-bold text-blue-950">Mapa do Site</h2>
        <p className="text-sm text-gray-500 mt-0.5">
          Todas as páginas e seções do portal organizadas por categoria.
        </p>
      </div>
    </div>

    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {sections.map(({ title, Icon, links }) => (
        <div
          key={title}
          className="bg-blue-50 border border-blue-100 rounded-2xl p-5 space-y-3"
        >
          <div className="flex items-center gap-2 pb-2 border-b border-blue-200">
            <Icon className="h-5 w-5 text-blue-700 flex-shrink-0" />
            <h3 className="font-bold text-blue-950 text-sm">{title}</h3>
          </div>
          <ul className="space-y-1">
            {links.map(({ name, href }) => (
              <li key={href}>
                <Link
                  to={href}
                  className="block text-sm text-gray-700 hover:text-blue-700 hover:underline py-0.5 transition-colors"
                >
                  {name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  </div>
);

export default SiteMap;
